import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NO_ERRORS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NbMomentDateModule } from "@nebular/moment";
import { NumberPickerModule } from "ng-number-picker";
import { TagInputModule } from "ngx-chips";

import { SenhaFormComponent } from "./components/senha-form/senha-form.component";
import { Ng5SliderModule } from "ng5-slider";
import { SharedModule } from "../shared/shared.module";
import { TextMaskModule } from "angular2-text-mask";
import { NgBrazil } from "ng-brazil";
import { NgxCurrencyModule } from "ngx-currency";
import { TranslateModule } from "@ngx-translate/core";

TagInputModule.withDefaults({
    tagInput: {
        placeholder: "Adicionar",
        // add here other default values for tag-input
    },
    dropdown: {
        displayBy: "my-display-value",
        // add here other default values for tag-input-dropdown
    },
});

import {
    NbActionsModule,
    NbCardModule,
    NbLayoutModule,
    NbMenuModule,
    //NbRouteTabsetModule,
    //NbSearchModule,
    NbSidebarModule,
    NbTabsetModule,
    NbThemeModule,
    NbUserModule,
    NbCheckboxModule,
    NbPopoverModule,
    NbContextMenuModule,
    //NbProgressBarModule,
    NbCalendarModule,
    NbCalendarRangeModule,
    NbStepperModule,
    NbButtonModule,
    NbInputModule,
    NbAccordionModule,
    NbDatepickerModule,
    NbDialogModule,
    NbWindowModule,
    NbListModule,
    NbToastrModule,
    NbAlertModule,
    NbSpinnerModule,
    NbRadioModule,
    NbSelectModule,
    //NbChatModule,
    //NbTooltipModule,
    NbCalendarKitModule,
} from "@nebular/theme";

import { NbSecurityModule } from "@nebular/security";

import {
    FooterComponent,
    HeaderComponent,
    SearchInputComponent,
    ThemeSettingsComponent,
    SwitcherComponent,
    LayoutDirectionSwitcherComponent,
    ThemeSwitcherComponent,
    ThemeSwitcherListComponent,
    ToggleSettingsButtonComponent,
} from "./components";
import { CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe, EvaIconsPipe } from "./pipes";
import {
    OneColumnLayoutComponent,
    SampleLayoutComponent,
    ThreeColumnsLayoutComponent,
    TwoColumnsLayoutComponent,
} from "./layouts";
import { DEFAULT_THEME } from "./styles/theme.default";
import { COSMIC_THEME } from "./styles/theme.cosmic";
import { CORPORATE_THEME } from "./styles/theme.corporate";
import { AgenciaSelecionarComponent } from "./layouts/sample/agencia-selecionar/agencia-selecionar.component";
import { TablefilterPipe } from "./pipes/tablefilter.pipe";

const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule];

const NB_MODULES = [
    TranslateModule,
    NbCardModule,
    NbLayoutModule,
    NbTabsetModule,
    //NbRouteTabsetModule,
    NbMenuModule,
    NbUserModule,
    NbActionsModule,
    //NbSearchModule,
    NbSidebarModule,
    NbCheckboxModule,
    NbPopoverModule,
    NbContextMenuModule,
    NgbModule,
    NbSecurityModule, // *nbIsGranted directive,
    //NbProgressBarModule,
    NbCalendarModule,
    //NbCalendarRangeModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbToastrModule,
    NbInputModule,
    NbAccordionModule,
    //NbDialogModule,
    NbWindowModule,
    NbAlertModule,
    NbSpinnerModule,
    NbRadioModule,
    NbSelectModule,
    //NbTooltipModule,
    NbDatepickerModule,
    //NbChatModule,
    NbCalendarKitModule,
    NbMomentDateModule,
    NumberPickerModule,
    TagInputModule,
    Ng5SliderModule,
    TextMaskModule,
    NgBrazil,
    NgxCurrencyModule,
];

const COMPONENTS = [
    SwitcherComponent,
    LayoutDirectionSwitcherComponent,
    ThemeSwitcherComponent,
    ThemeSwitcherListComponent,
    HeaderComponent,
    FooterComponent,
    SearchInputComponent,
    ThemeSettingsComponent,
    OneColumnLayoutComponent,
    SampleLayoutComponent,
    ThreeColumnsLayoutComponent,
    TwoColumnsLayoutComponent,
    ToggleSettingsButtonComponent,
];

const ENTRY_COMPONENTS = [ThemeSwitcherListComponent];

const PIPES = [CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, TablefilterPipe, NumberWithCommasPipe, EvaIconsPipe];

const NB_THEME_PROVIDERS = [
    ...NbThemeModule.forRoot(
        {
            name: "default",
        },
        [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME]
    ).providers,
    ...NbSidebarModule.forRoot().providers,
    ...NbMenuModule.forRoot().providers,
    ...NbDatepickerModule.forRoot().providers,
    ...NbDialogModule.forRoot().providers,
    ...NbWindowModule.forRoot().providers,
    ...NbToastrModule.forRoot().providers,
];

@NgModule({
    imports: [...BASE_MODULES, ...NB_MODULES, SharedModule],
    exports: [...BASE_MODULES, ...NB_MODULES, ...COMPONENTS, ...PIPES],
    declarations: [...COMPONENTS, ...PIPES, SenhaFormComponent, AgenciaSelecionarComponent, TablefilterPipe],
    entryComponents: [...ENTRY_COMPONENTS],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ThemeModule {
    static forRoot(): ModuleWithProviders {
        return <ModuleWithProviders>{
            ngModule: ThemeModule,
            providers: [...NB_THEME_PROVIDERS],
        };
    }
}
